import { NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StableDialogComponent } from './stable-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { DialogLayoutModule } from '@tcc-mono/shared/ui/dialog-layout';
import { DisplayRelationPropertyModule } from '@tcc-mono/vandijk/shared/ui/property-displayers/display-relation-property';
import { SharedUtilsModule } from '@tcc-mono/shared/utils';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';

@NgModule({
  imports: [
    CommonModule,
    DialogLayoutModule,
    ReactiveFormsModule,
    IonicModule,
    FontAwesomeModule,
    TranslocoModule,
    DisplayRelationPropertyModule,
    SharedUtilsModule
  ],
  declarations: [StableDialogComponent],
  exports: [StableDialogComponent]
})
export class StableDialogModule {
  private readonly _lib = inject(FaIconLibrary);

  constructor() {
    this._lib.addIcons(faArrowRight);
  }
}
